<template>
  <div class="content">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'LayoutContent'
}
</script>

<style lang="scss" scoped>

</style>
